/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { resourceWithCurrentSchemesSchema } from './resourceWithCurrentSchemesSchema';

export const pageResponseResourceWithCurrentSchemesSchema = z.object({
  cursor: z.string().nullish(),
  get data() {
    return z.array(resourceWithCurrentSchemesSchema);
  },
  hasNextPage: z.boolean().nullish(),
  recordCount: z.int().nullish(),
  recordLimit: z.int().nullish(),
});
